import { render, staticRenderFns } from "./DocCard.vue?vue&type=template&id=3317b281&scoped=true"
import script from "./DocCard.vue?vue&type=script&lang=js"
export * from "./DocCard.vue?vue&type=script&lang=js"
import style0 from "./DocCard.vue?vue&type=style&index=0&id=3317b281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3317b281",
  null
  
)

export default component.exports